export default __webpack_public_path__ + "static/media/event_white.56f5095d.svg";